import { render, staticRenderFns } from "./ToDoListForm.vue?vue&type=template&id=251bc3d4&scoped=true&"
import script from "./ToDoListForm.vue?vue&type=script&lang=js&"
export * from "./ToDoListForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251bc3d4",
  null
  
)

export default component.exports